export default class FloatingContact {
  constructor(id = 'denhaag-floating-contact') {
    this.element = document.getElementById(id);

    if (!this.element) {
      return;
    }

    // On initial load
    this.handleWindowResize();
    // On user interaction
    window.addEventListener( 'dh:resize', this.handleWindowResize.bind( this ) );

    this.toggle = document.getElementById(`${id}-switch`);

    if (!this.toggle) {
      return;
    }

    this.labelWrapper = document.getElementById(`${id}__label`);

    if (!this.labelWrapper) {
      return;
    }

    this.toggle.onclick = () => this.toggleEvents();
    this.element.addEventListener('keydown', (event) => this.keyBoardEvents(event));
  }

  /**
   * Toggle event. Fires onclick of the label.
   *
   * Only `aria-expanded` is toggled; the links follow the overlay's `display`, so they are never
   * focusable while it is hidden and always focusable while it is shown — including the always-open
   * layout at 400% zoom and on high density screens, where this toggle itself is hidden.
   */
  toggleEvents() {
    const state = this.toggle.getAttribute('aria-expanded') === 'false';
    this.toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
  }

  keyBoardEvents(event) {
    const floatingContactSwitchExpanded = this.element
      ?.querySelector('.denhaag-floating-contact-switch')
      .getAttribute('aria-expanded');

    // escape key
    if (event.key === 'Escape' && floatingContactSwitchExpanded === 'true') {
      setTimeout(() => {
        this.toggleEvents();
        this.toggle.focus();
      }, 1);
    }

    // tab forwards
    if (!event.shiftKey && event.key === 'Tab' && floatingContactSwitchExpanded === 'true') {
      setTimeout(() => {
        // this must be located inside timeout, because of the key event delay
        const floatingContactItemLinkFocus = document.activeElement.classList.contains(
          'denhaag-floating-contact__item-link',
        );

        if (!floatingContactItemLinkFocus) {
          this.toggleEvents();
        }
      }, 1);
    }

    // tab backwards
    if (event.shiftKey && event.key === 'Tab') {
      setTimeout(() => {
        // this must be located inside timeout, because of the key event delay
        const floatingContactSwitchFocus = document.activeElement.classList.contains('denhaag-floating-contact-switch');
        const floatingContactItemLinkFocus = document.activeElement.classList.contains(
          'denhaag-floating-contact__item-link',
        );

        if (!floatingContactSwitchFocus && floatingContactSwitchExpanded === 'true' && !floatingContactItemLinkFocus) {
          this.toggleEvents();
        }
      }, 1);
    }
  }

  handleWindowResize() {
    if (window.innerHeight < (this.element?.offsetHeight || 0)) {
      this.addZoomedClass();
    } else {
      if (this.hasZoomedClass()) {
        this.removeZoomedClass();
      }
    }
  }

  hasZoomedClass() {
    return this.element?.classList.contains('denhaag-floating-contact--zoomed');
  }

  addZoomedClass() {
    this.element?.classList.add('denhaag-floating-contact--zoomed');
  }

  removeZoomedClass() {
    this.element?.classList.remove('denhaag-floating-contact--zoomed');
  }
}
